import React from "react";
import { Link } from "react-router-dom";
import Fav from "../../Misc/Fav";
export default function JournalListItem(props) {
  const clickHandler = (e) => {
    if (props.onPick) {
      e.preventDefault();
    }
  };

  const dblClickHandler = (e) => {
    if (props.onPick) {
      e.preventDefault();
      props.onPick(props);
    }
  };

  let nodeId = props.nodeId || "any";
  return (
    <>
      <Link
        onClick={(e) => clickHandler(e)}
        onDoubleClick={(e) => dblClickHandler(e)}
        to={`/journal/${nodeId}/${props.id}/`}
      >
        <div
          className={`row py-4 px-2 border-bottom text-dark bg-hover-light ${
            props.highlightItem === String(props.id) ? "bg-light" : ""
          }`}
        >
          <div className="col-lg-12 m-lg-0 my-3">
            <div>
              {props.label}
              <Fav className="ml-1" itemId={props.id} item={props} />
            </div>

            {props.description && (
              <div className="text-dark-75 small">{props.description}</div>
            )}
          </div>
        </div>
      </Link>
    </>
  );
}
